import { useState, useEffect, useMemo } from 'react';
import { navigate } from 'gatsby';

const usePagination = ({ tiles = [], tilesPerPage = 8, seoTitle }) => {
	const queryParams = useMemo(() => {
		if (typeof window !== 'undefined') {
			return new URLSearchParams(window.location.search);
		}
		return new URLSearchParams();
	}, []);

	const initialPage = parseInt(queryParams.get('page')) || 1;
	const [currentPage, setCurrentPage] = useState(initialPage);
	const [title, setTitle] = useState(seoTitle);
	const pageCount = Math.ceil(tiles?.length / tilesPerPage) || 0;
	const isLastPage = currentPage === pageCount;

	useEffect(() => {
		if (currentPage !== initialPage) {
			if (currentPage !== 1) {
				queryParams.set('page', currentPage);
				navigate(`?${queryParams.toString()}`);
			} else {
				queryParams.delete('page');
				navigate(`?${queryParams.toString()}`);
			}
		}
	}, [currentPage, queryParams, initialPage]);

	useEffect(() => {
		if (currentPage > 1) {
			setTitle(`${seoTitle} - Page ${currentPage} Results | Pella`);
		} else {
			setTitle(`${seoTitle} | Pella`);
		}
	}, [currentPage, seoTitle]);

	return {
		currentPage,
		setCurrentPage,
		pageCount,
		title,
		isLastPage,
	};
};

export default usePagination;
